export default {
  Table_Common: {
    TuoDong: '拖动',
    ZhuanJieMa_MingCheng: '转介码名称',
    ZhuanJie_Ma: '转介码',
    TingYon_ZhuanTai: '停用状态',
    ChuangJian_ShiJian: '创建时间',
    DengLu_ShiJian: '登录时间',
    YongHu: '用户',
    DengLu: '登录',
    DengChu: '登出',
    PiLiang_TiChu: '批量踢出',
    ChengGong: '成功',
    ShiBai: '失败',
    CuoWu_Ma: '错误码',
    DengLu_IP: '登录IP',
    JiaZai_Zhong: '加载中',
    ShouJi_HaoMa: '手机号码',
    DianHua: '电话',
    XingBie: '性别',
    ZhiGong_LeiBie: '职工类别',
    ZhenJin: '诊金',
    Yuan: '元',
    JueSe: '角色',
    ShuJu_QuanXian: '数据权限',
    QuanXian_FanWei: '权限范围',
    ShiYong_ZhenSuo: '适用诊所',
    YuanGong_ZhuangTai: '员工状态',
    QiYong: '启用',
    TingYong: '停用',
    TingYong_BiaoShi: '（停用）',
    ShiFou_CanYu_PaiBan: '是否参与排班',
    ShiFou_PaiBan: '是否排班',
    Shi: '是',
    Fou: '否',
    PaiBan: '排班',
    YouXiang: '邮箱',
    ChuSheng_RiQi: '出生日期',
    CaoZuo: '操作',
    Nan: '男',
    Nv: '女',
    MiaoShu: '描述',
    CaiDan_MingCheng: '菜单名称',
    LuYou: '路由',
    GongNeng_QuanXian: '功能权限',
    YaoFei: '药费',
    ZhenJiu_JinE: '针灸金额',
    TaoPiao: '套票',
    YouFei: '邮费',
    ZhenJin_JinE: '诊金金额',
    TuiNa_ZhengGu: '推拿/正骨',
    BaGuan_JinE: '拔罐金额',
    YouHuiQuan_MingCheng: '优惠券名称',
    QiYong_ZhuangTai: '启用状态',
    MianE: '面额',
    ManJian_MuBiao_JinE: '满减目标金额',
    ShiYong_QingKuang: '使用情况',
    Yi_ShiYong: '已使用',
    Yi_Shou: '已售',
    ShiFou_YiShou: '是否已售',
    Yi_FaFang: '已发放',
    ShiYong_DanJu: '适用单据',
    GuoQi_ShiJian: '过期时间',
    ShiYong_GuoQi_ShiJian: '使用过期时间',
    YouXiaoQi: '有效期',
    ChangQiYouXiao: '长期有效',
    FaFangQi_ShiChang: '发放起 {duration}{unit}',
    GouMaiQi_ShiChang: '购买起 {duration}{unit}',
    Zhi_RiQi: '至 {date}',
    ShouMai_ShiJian: '售卖时间',
    ShouMai_JieShu: '{date}结束',
    GuoQi_RiQi: '过期日期',
    HuanZhe_XingMing: '患者姓名',
    LaiYuan: '来源',
    YiShi_Duan: '医师端',
    GuanLi_Duan: '管理端',
    JianDang_ShiJian: '建档时间',
    ShouHuo_Ren: '收货人',
    YiDong_SheZhi: '移动设置',
    MoRen_DiZhi: '默认地址',
    SheWei_MoRen: '设为默认',
    ChanPin_MingCheng_En: '产品名称(EN)',
    YaoPin_MingCheng_En: '药品名称(En)',
    BianMa: '编码',
    GuiGe_En: '规格(EN)',
    NongSuo: '浓缩',
    JingZhong: '净重',
    DanWei_ChengBen_Jia: '单位成本价',
    DanWei_ShouJia: '单位售价',
    KuCun: '库存',
    ChuFang_DanWei: '处方单位',
    YaoPin_ZhuangTai: '药品状态',
    GuiGe_ZhuangTai: '规格状态',
    ChengFen_Yao: '成分药',
    DingDan_ZhuangTai: '订单状态',
    DingDan_JinE: '订单金额',
    XiaDan_Ren: '下单人',
    ShenPi_Ren: '审批人',
    GengXin_ShiJian: '更新时间',
    ShenPi_ShiJian: '审批时间',
    ChengBen_Jia: '成本价',
    XiaDan_ShuLiang: '下单数量',
    QianShou_ShuLiang: '签收数量',
    Yi_QianShou: '已签收',
    BenCi_QianShou: '本次签收',
    QianShou_ShiJian: '签收时间',
    ShenPi_Zhong: '审批中',
    Dai_QianShou: '待签收',
    Yi_WanCheng: '已完成',
    BoHui: '驳回',
    Yi_ZuoFei: '已作废',
    DiaoZheng_RenYuan: '调整人员',
    ShenHe_RenYuan: '审核人员',
    DiaoZheng_Qian_KuCun: '调整前库存',
    DiaoZheng: '调整',
    DiaoZheng_Hou_KuCun: '调整后库存',
    XiangMu_MingCheng: '项目名称',
    ZhongLei: '种类',
    JiFei: '计费',
    HanLiang: '含量',
    ChongZhi_JinE: '充值金额',
    ZengSong_JinE: '赠送金额',
    ShiFou_ShouChong: '是否首充',
    YuE: '余额',
    GuiGe: '规格',
    JingMai: '经脉',
    XueWei: '穴位',
    FangFa: '方法',
    WeiZhi: '位置',
    DanWei: '单位',
    XiangMu: '项目',
    ZiTou: '字头',
    RiQi_GeShi: '日期格式',
    BuLing: '补零',
    QiShi: '起始',
    LeiXing: '类型',
    ShuLiang: '数量',
    KeHu_BianHao: '客户编号',
    JiuZhen: '就诊',
    HeJi: '合计',
    XueWei_GeShu: '穴位个数',
    DanJu_LeiXing: '单据类型',
    ShiYong_CiShu: '使用次数',
    YouHui_JinE_XianZhi: '优惠金额限制',
    ZhongYi_ChuFang: '中医处方',
    ZhongYi_ChuFang_Zhen: '中医处方(针)',
    ZhongYi_ChuFang_Tui: '中医处方(推)',
    ZhongYi_ChuFang_Ba: '中医处方(拔)',
    BingLi_BaoGao: '病历报告',
    BingJia_ZhengMingShu: '病假证明书',
    DaoZhen_ZhengMingShu: '到诊证明书',
    HuaiYun_ZhengMingShu: '怀孕证明书',
    ShouJu: '收据',
    ZhuanJie_Xin: '转介信',
    DaYin_ShiJian: '打印时间',
    DaYin_Ren: '打印人',
    DaYin_ZhenSuo: '打印诊所',
    GuanLiYuan: '管理员',
    Biaozhun: '标准',
    GuiGe_BianMa: '规格编码',
    PinYin: '拼音',
    YaoPing_GuiGe: '药品规格',
    NongDu: '浓度',
    ShiFou_NongSuo: '是否浓缩',
    TiaoMa: '条码',
    PiCiHao: '批次号',
    HuiYuan_MiaoShu: '会员描述',
    HuiYuan_MiaoShu_En: '描述（En）',
    GuiShu_ZhenSuo: '归属诊所',
    CaiDan: '菜单',
    MoRen_DanWei_ChengBenjia: '默认单位成本价',
    MoRen_DanWei_ShouJia: '默认单位售价',
    DingDan_YaoPing_ShuLiang: '采购数量',
    XiangMu_ShuLiang: '项目数量',
    DingGou_Zong_ShuLiang: '订购总数量',
    YaoFang: '药方',
    ShiFou_GongKai: '是否公开',
    ChuangJian_Ren: '创建人',
    YingXiao_LeiXing: '营销类型',
    DingJia_FangShi: '定价方式',
    HuoDong_JiaGe: '活动价格',
    HuoDong_ZheKou: '活动折扣',
    HuoDong_ShangPin: '活动商品',
    Xiang_JinE: '现金额',
    BianDong_JinE: '变动金额',
    ErWeiMa: '二维码',
    FaFang_CiShu: '发放次数',
    YaoPin_PiHao: '药品批号',
    CaiGou: '采购',
    PanDian: '盘点',
    BianDong_Qian_KuCun: '变动前库存',
    BianDong_Zhi: '变动值',
    BianDong_Hou_KuCun: '变动后库存',
    LaiYuan_DanJuHao: '来源单据号',
    CaoZuo_RenYuan: '操作人员',
    CaoZuo_ShiJian: '操作时间',
    HuanZhe_BianHao: '患者编号',
    YuYue_ShiJian: '预约时间',
    TuiJian_YuanYin: '推荐原因',
  },
}
